import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlainTextComponent } from './plain-text/plain-text.component';
import { EditorModule } from '@progress/kendo-angular-editor';



@NgModule({
  declarations: [
    PlainTextComponent
  ],
  imports: [
    CommonModule,
    EditorModule,
  ],
  exports: [ PlainTextComponent ]
})
export class EmailPlainTextModule { }
